import {
  BoatIcon,
  BusIcon, GroupIcon,
  IndividualIcon,
  TrainIcon,
  TransportationMethodOtherIcon
} from "@kursk/components/ui/icons.astrakhan";
import { CarIcon } from "@kursk/components/ui/icons";
import React from "react";

const TOUR_TRANSPORTATION_METHOD_HASHES = {
  other: {
    icon: <TransportationMethodOtherIcon />,
    title: 'Другое',
  },
  bus: {
    icon: <BusIcon />,
    title: 'На автобусе',
  },
  auto: {
    icon: <CarIcon />,
    title: 'Автомобильный',
  },
  boat: {
    icon: <BoatIcon />,
    title: 'На теплоходе',
  },
  train: {
    icon: <TrainIcon />,
    title: 'На поезде',
  },
}

const TOUR_TRANSPORTATION_METHOD_TITLES = Object.entries(TOUR_TRANSPORTATION_METHOD_HASHES)
  .reduce((acc, [key, { title }]) => {
    acc[key] = title;

    return acc;
  }, {});

const TOUR_TYPE_HASHES = {
  individual: {
    icon: <IndividualIcon />,
    title: 'Индивидуальный',
  },
  group: {
    icon: <GroupIcon />,
    title: 'Групповой'
  }
}

const TOUR_TYPE_TITLES = Object.entries(TOUR_TYPE_HASHES)
  .reduce((acc, [key, { title }]) => {
    acc[key] = title;

    return acc;
  }, {});

export const TOUR_SINGLE_HASHES = {
  transportationMethod: TOUR_TRANSPORTATION_METHOD_HASHES,
  type: TOUR_TYPE_HASHES
}

export const TOUR_MULTIPLE_HASHES = {
  transportationMethod: {
    icon: <TransportationMethodOtherIcon />,
    titles: TOUR_TRANSPORTATION_METHOD_TITLES
  },
  type: {
    icon: <GroupIcon />,
    titles: TOUR_TYPE_TITLES
  }
}
